import { render, staticRenderFns } from "./CashRegisterForm.vue?vue&type=template&id=24ab2aa6"
import script from "./CashRegisterForm.vue?vue&type=script&lang=js"
export * from "./CashRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports